(function () {
  'use strict';

  function initParallax() {
    var sections = document.querySelectorAll('.parallax-container');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var imageOne = section.querySelector('.parallax--one');
      var imageTwo = section.querySelector('.parallax--two');

      if (!imageOne && !imageTwo) return;

      function updateParallax() {
        var rect = section.getBoundingClientRect();
        var windowHeight = window.innerHeight;
        var sectionTop = rect.top;
        var sectionCenter = rect.top + rect.height / 2;
        var viewportCenter = windowHeight / 2;

        // Calculate distance from viewport center
        // Positive when section is below center, negative when above
        var distanceFromCenter = sectionCenter - viewportCenter;

        // Use a range for smoother, more gradual movement
        // Smaller range = more movement, larger range = less movement
        var parallaxRange = windowHeight * 0.8; // Reduced range for more movement

        // Normalize distance to -1 to 1 range, then apply easing
        var normalizedDistance = Math.max(-1, Math.min(1, distanceFromCenter / parallaxRange));

        // Apply easing function for smoother movement (ease-in-out curve)
        var easedDistance =
          normalizedDistance < 0
            ? -Math.pow(Math.abs(normalizedDistance), 0.7) // Ease out when going up
            : Math.pow(normalizedDistance, 0.7); // Ease out when going down

        // Different speeds for each image - increased for more movement
        var speedOne = 0.5; // Image one moves slower
        var speedTwo = 0.7; // Image two moves faster

        // Limit upward movement to prevent images from being cut off
        // Image one has more restrictive upward limit
        var maxUpwardMovementOne = -18; // Maximum pixels image one can move up
        var maxDownwardMovementOne = 60; // Maximum pixels image one can move down
        var maxUpwardMovementTwo = -40; // Maximum pixels image two can move up
        var maxDownwardMovementTwo = 80; // Maximum pixels image two can move down

        if (imageOne) {
          // Scale the eased distance to the movement range
          var translateYOne = easedDistance * (maxDownwardMovementOne - maxUpwardMovementOne) * speedOne;
          // Clamp the value to prevent going too high or too low
          translateYOne = Math.max(maxUpwardMovementOne, Math.min(maxDownwardMovementOne, translateYOne));
          imageOne.style.transform = 'translateY(' + translateYOne + 'px)';
        }

        if (imageTwo) {
          // Scale the eased distance to the movement range
          var translateYTwo = easedDistance * (maxDownwardMovementTwo - maxUpwardMovementTwo) * speedTwo;
          // Clamp the value to prevent going too high or too low
          translateYTwo = Math.max(maxUpwardMovementTwo, Math.min(maxDownwardMovementTwo, translateYTwo));
          imageTwo.style.transform = 'translateY(' + translateYTwo + 'px)';
        }
      }

      // Initial update
      updateParallax();

      // Throttle scroll events for performance
      var ticking = false;
      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            updateParallax();
            ticking = false;
          });
          ticking = true;
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', updateParallax, { passive: true });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParallax);
  } else {
    initParallax();
  }

  // Re-initialize when section is loaded in theme editor
  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail && event.detail.sectionId) {
      var section = document.querySelector('[data-section-id="' + event.detail.sectionId + '"]');
      if (section && section.closest('.newsletter-banner')) {
        initParallax();
      }
    }
  });
})();
